import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import bases from '@/store/moddules/base'
import isShow from "@/store/moddules/isShow";
import user from "@/store/moddules/user";

Vue.use(Vuex)

export default new Vuex.Store({
  strict:true,
  state: {
    ProId: 0
  },
  mutations: {
    setProId(state, idx) {
      state.ProId = idx;
    }
  },
  actions: {
  },
  modules: {
    bases,
    isShow,
    user
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage//或者window.locationStorage
  })]
})
